import { Injectable } from '@angular/core';
import { exportToCsv, exportToCsvWithColor, exportToExcel, getBrokersList, isDecimal } from 'src/app/utils/utils.common';
import * as moment from 'moment-timezone';

@Injectable({
  providedIn: 'root'
})
export class CsvService {

  constructor(

  ) { }

  generateTripItineraryReport(trips, date, timezone, preCooperates) {

    const table = [
      [
        "trip_id",
        "trip_status",
        "created_at",
        "service_area",
        "pu_address",
        "pu_date",
        "do_address",
        "do_date",
        "actual_miles",
        "funding_source",
        "source",
        "track_id",
        "los",
        "space_type",
        "ipa_number",
        "passenger_name",
        "phone_number",
        "cell_phone",
        "client_id",
        "insurance_id",
        "dob",
        "weight",
        "driver_name",
        "odometer_begin",
        "odometer_start",
        "odometer_end",
        "dead_miles",
        "dead_minutes",
        "wait_time",
        "trip_miles",
        "trip_time",
        "total_trip_miles",
        "total_trip_time",
        "total_trip_miles_+_dead_miles",
        "total_trip_time_+_dead_minutes",
        "driver_notes",
        "biller_notes",
        "dispatcher_notes",
        "accepted_time",
        "accepted_coords",
        "onscene_time",
        "onscene_coords",
        "started_time",
        "started_coords",
        "ended_time",
        "ended_coords",
        "finished_time",
        "finished_coords",
        "BSR",
        "change_reason"
      ]];
    trips.forEach(trip => {
      let acceptedDate, pickupDate, arrivedDate, endDate, finishDate, scheduleTime, appointmentTime, createdAt = ' ';
      if (trip.scheduleTime) {
        scheduleTime = moment(trip.scheduleTime).tz(timezone).format("MMM DD, YYYY : HH:mm");
      }
      if (trip.createdAt) {
        createdAt = moment(trip.createdAt).tz(timezone).format("MMM DD, YYYY : HH:mm");
      }
      if (trip.appointmentTime) {
        appointmentTime = moment(trip.appointmentTime).tz(timezone).format("MMM DD, YYYY : HH:mm");
      }
      if (trip.job) {
        if (trip.job.trackInfoJob) {
          if (trip.job.trackInfoJob.jobAccepted) {
            if (trip.job.trackInfoJob.jobAccepted.time) {
              acceptedDate = moment(trip.job.trackInfoJob.jobAccepted.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
            }
          }
          if (trip.job.trackInfoJob.jobArrived) {
            if (trip.job.trackInfoJob.jobArrived.time) {
              pickupDate = moment(trip.job.trackInfoJob.jobArrived.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
            }
          }
          if (trip.job.trackInfoJob.jobStarted) {
            if (trip.job.trackInfoJob.jobStarted.time) {
              arrivedDate = moment(trip.job.trackInfoJob.jobStarted.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
            }
          }
          if (trip.job.trackInfoJob.jobCompleted) {
            if (trip.job.trackInfoJob.jobCompleted.time) {
              endDate = moment(trip.job.trackInfoJob.jobCompleted.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
            }
          }
          
          if (trip.job.trackInfoJob.jobFinished) {
              if (trip.job.trackInfoJob.jobFinished.time) {
                finishDate = moment(trip.job.trackInfoJob.jobFinished.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
              }
            }
          
        }

      }

      let data = [
        trip.tripId ? trip.tripId : ' ',
        trip.status ? trip.status : ' ',
        createdAt ? createdAt : ' ',
        trip.jobOriginAddress ? trip.jobOriginAddress : ' ',
        scheduleTime ? scheduleTime : ' ',
        trip.jobDestinationAddress ? trip.jobDestinationAddress : ' ',
        appointmentTime ? appointmentTime : ' ',
        trip.milage ? trip.milage : ' ',
        preCooperates[trip.cooperate] ? preCooperates[trip.cooperate].displayName : ' ',
        trip.rawId ? "Parsed" : "Manual",
        trip.trackId ? trip.trackId : ' ',
        trip.ipa ? trip.ipa : ' ',
        trip.priorityClient && trip.priorityClient.displayName ? trip.priorityClient.displayName : ' ',
        trip.priorityClient && trip.priorityClient.contactNumber ? trip.priorityClient.contactNumber : ' ',
        trip.priorityClient && trip.priorityClient.cellPhone ? trip.priorityClient.cellPhone : ' ',
        trip.priorityClient && trip.priorityClient.clientId ? trip.priorityClient.clientId : ' ',
        trip.priorityClient && trip.priorityClient.memberId ? trip.priorityClient.memberId : ' ',
        trip.dob ? trip.dob : ' ',
        trip.weight ? trip.weight : ' ',
        trip.driver ? trip.driver.displayName : ' ',
        trip.job ? trip.job.odometerBegin : ' ',
        trip.job ? trip.job.odometerStart : ' ',
        trip.job ? trip.job.odometerStop : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.surchargeMiles ? trip.job.additionalInfoJob.surchargeMiles : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.surchargeMinutes ? trip.job.additionalInfoJob.surchargeMinutes : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.jobWaitTime ? trip.job.additionalInfoJob.jobWaitTime : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.totalMiles ? trip.job.additionalInfoJob.totalMiles : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.jobMinutes ? trip.job.additionalInfoJob.jobMinutes : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.jobTotalMiles ? trip.job.additionalInfoJob.jobTotalMiles.toFixed(2) : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.jobTotalTime ? trip.job.additionalInfoJob.jobTotalTime.toFixed(2) : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.surchargeMiles && trip.job.additionalInfoJob.jobTotalMiles ? (trip.job.additionalInfoJob.jobTotalMiles + trip.job.additionalInfoJob.surchargeMiles).toFixed(2) : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.surchargeMinutes && trip.job.additionalInfoJob.jobTotalTime ? (trip.job.additionalInfoJob.jobTotalTime + trip.job.additionalInfoJob.surchargeMinutes).toFixed(2) : ' ',
        trip.companyNote ? trip.companyNote : ' ',
        trip.billerNote ? trip.billerNote : ' ',
        trip.dispatchNoteTwo ? trip.dispatchNoteTwo : ' ',
        acceptedDate ? acceptedDate : ' ',
        trip.job && trip.job.trackInfoJob && trip.job.trackInfoJob.jobAccepted && trip.job.trackInfoJob.jobAccepted.time ? [trip.job.trackInfoJob.jobAccepted.coords[0], trip.job.trackInfoJob.jobAccepted.coords[1]].toString() : ' ',
        pickupDate ? pickupDate : ' ',
        trip.job && trip.job.trackInfoJob && trip.job.trackInfoJob.jobArrived && trip.job.trackInfoJob.jobArrived.time ? [trip.job.trackInfoJob.jobArrived.coords[0], trip.job.trackInfoJob.jobArrived.coords[1]].toString() : ' ',
        arrivedDate ? arrivedDate : ' ',
        trip.job && trip.job.trackInfoJob && trip.job.trackInfoJob.jobStarted && trip.job.trackInfoJob.jobStarted.time ? [trip.job.trackInfoJob.jobStarted.coords[0], trip.job.trackInfoJob.jobStarted.coords[1]].toString() : ' ',
        endDate ? endDate : ' ',
        trip.job && trip.job.trackInfoJob && trip.job.trackInfoJob.jobCompleted && trip.job.trackInfoJob.jobCompleted.time ? [trip.job.trackInfoJob.jobCompleted.coords[0], trip.job.trackInfoJob.jobCompleted.coords[1]].toString() : ' ',
        finishDate ? finishDate : ' ',
        trip.job && trip.job.trackInfoJob && trip.job.trackInfoJob.jobFinished && trip.job.trackInfoJob.jobFinished.time ? [trip.job.trackInfoJob.jobFinished.coords[0], trip.job.trackInfoJob.jobFinished.coords[1]].toString() : " ",
        trip.preSpecialRate ? trip.preSpecialRate : ' ',
        trip.changeReason ? trip.changeReason : ' ',
      ]
      table.push(data)
    });

    exportToCsv(`reports-${moment(date[0]).tz(timezone).format("MM-DD-YYYY")}-${moment(date[1]).tz(timezone).format("MM-DD-YYYY")}.csv`, table);
  }

  driverMonitoringReport(trips, date, timezone) {
    let data;
    let actualPickup, scheduleTime, appointmentTime, actualDropOff, pickupDuration, dropOffDuration;
    let status;
    let dropOffStatus


    const table = [
      [
        "Date",
        "Driver",
        'Patient',
        'Req Pickup',
        'Pick up Arrive',
        'Status(PU)',
        'Duration',
        'Appointment',
        'Dropoff Arrive',
        'Status (Appt)',
        'Duration',
        'Status',
        'Comments'
      ]];
    trips.forEach(trip => {

      if (trip.job) {
        if (trip.scheduleTime) {
          scheduleTime = moment(trip.scheduleTime).tz(timezone).format("HH:mm a");
        }
        if (trip.appointmentTime) {
          appointmentTime = moment(trip.appointmentTime).tz(timezone).format("HH:mm a");
        }
        if (trip.job.trackInfoJob) {
          if (trip.job.trackInfoJob.jobArrived) {
            if (trip.job.trackInfoJob.jobArrived.time) {
              actualPickup = moment(trip.job.trackInfoJob.jobArrived.time).tz(timezone).format("HH:mm a");
              pickupDuration = moment(trip.scheduleTime).diff(moment(trip.job.trackInfoJob.jobArrived.time));
              pickupDuration = (pickupDuration / 60000).toFixed(0);

              const isEarly = moment(trip.scheduleTime).isAfter(moment(trip.job.trackInfoJob.jobArrived.time));
              const diff = pickupDuration
              if (isEarly) {
                if (diff <= 15) {
                  status = "On Time";
                } else {
                  status = "Early";
                }
              } else {
                if (Math.abs(diff) <= 15) {
                  status = "On Time";
                } else {
                  status = "Late";
                }
              }
            }


          }
          if (trip.job.trackInfoJob.jobCompleted) {
            if (trip.job.trackInfoJob.jobCompleted.time) {
              actualDropOff = moment(trip.job.trackInfoJob.jobCompleted.time).tz(timezone).format("HH:mm a");
              dropOffDuration = moment(trip.appointmentTime).diff(moment(trip.job.trackInfoJob.jobCompleted.time))
              dropOffDuration = (dropOffDuration / 60000).toFixed(0)
              const isLate = moment(trip.appointmentTime).isAfter(moment(trip.job.trackInfoJob.jobCompleted.time));
              const diff = dropOffDuration
              if (isLate) {
                if (diff <= 15) {
                  dropOffStatus = "On Time";
                } else {
                  dropOffStatus = "Early";
                }
              } else {
                if (Math.abs(diff) <= 15) {
                  dropOffStatus = "On Time";
                } else {
                  dropOffStatus = "Late";
                }
              }


            }
          }

        }
      }




      data = [
        moment(trip.scheduleTime).tz(timezone).format("MM/DD/YYYY"),
        trip.driver ? trip.driver.displayName : ' ',
        trip.priorityClient ? trip.priorityClient.displayName : ' ',
        scheduleTime ? scheduleTime : ' ',
        actualPickup ? actualPickup : ' ',
        status ? status : ' ',
        pickupDuration ? pickupDuration : ' ',
        appointmentTime ? appointmentTime : ' ',
        actualDropOff ? actualDropOff : ' ',
        dropOffStatus ? dropOffStatus : ' ',
        dropOffDuration ? dropOffDuration : ' ',
        trip.status,
        trip.cancelReason ? trip.cancelReason : ' '
      ]
      table.push(data)
    });


    exportToCsv(`on-scene-report-${moment(date[0]).tz(timezone).format("MM/DD/YYYY") + "-" + moment(date[1]).tz(timezone).format("MM/DD/YYYY")}.csv`, table);
  }

  viewHourFormat(milli) {
    let duration = moment.duration(milli, 'milliseconds');
    return `${Math.floor(duration.asHours())}hr ${duration.minutes()}mins`;
  }
}
